/* Icon factory: takes an SVG path string and returns a component.
   Named so React DevTools and eslint's display-name rule are happy. */
const Icon = (paths) =>
  function IconGlyph({ className = "", size = 16, ...rest }) {
    return (
      <svg
        {...rest}
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        dangerouslySetInnerHTML={{
          __html: paths,
        }}
      />
    );
  };

const I_Home = Icon('<path d="M3 9.5 12 3l9 6.5V21a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1Z"/>');

const I_Users = Icon(
  '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
);

const I_Building = Icon(
  '<path d="M3 22h18"/><path d="M5 22V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v18"/><path d="M9 6h.01"/><path d="M13 6h.01"/><path d="M9 10h.01"/><path d="M13 10h.01"/><path d="M9 14h.01"/><path d="M13 14h.01"/>',
);

const I_Cal = Icon(
  '<rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/>',
);

const I_Pulse = Icon('<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>');

const I_Settings = Icon(
  '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
);

const I_Search = Icon('<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>');

const I_Plus = Icon('<path d="M5 12h14"/><path d="M12 5v14"/>');

const I_X = Icon('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>');

const I_Phone = Icon(
  '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>',
);

const I_Msg = Icon('<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>');

const I_Chev = Icon('<path d="m9 18 6-6-6-6"/>');

const I_ChevDown = Icon('<path d="m6 9 6 6 6-6"/>');

const I_LogOut = Icon(
  '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>',
);

const I_Spark = Icon(
  '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>',
);

const I_Img = Icon(
  '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
);

const I_Doc = Icon(
  '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
);

const I_Trash = Icon(
  '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
);

const I_Edit = Icon('<path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>');

const I_Check = Icon('<polyline points="20 6 9 17 4 12"/>');

const I_Up = Icon(
  '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>',
);

const I_Down = Icon(
  '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>',
);

const I_Alert = Icon(
  '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
);

const I_Clock = Icon('<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>');

const I_Flame = Icon(
  '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',
);

const I_Snooze = Icon(
  '<circle cx="12" cy="13" r="8"/><path d="M5 3 2 6"/><path d="m22 6-3-3"/><path d="M6.38 18.7 4 21"/><path d="M17.64 18.67 20 21"/><path d="M9 13h6l-6 5h6"/>',
);

const I_Send = Icon('<path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/>');

const I_Filter = Icon('<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>');

const I_Pin = Icon(
  '<path d="M20 10c0 7-8 13-8 13s-8-6-8-13a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>',
);

const I_Ind = Icon('<path d="M3 3v18h18"/><path d="m7 14 4-4 4 4 5-5"/>');

const I_Refresh = Icon(
  '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
);

const I_User = Icon(
  '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
);

const I_Camera = Icon(
  '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/>',
);

const I_Inbox = Icon(
  '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
);

const I_Layers = Icon(
  '<path d="m12.83 2.18 9.17 4.59-9.17 4.58-9.17-4.58 9.17-4.59Z"/><path d="m22 17.18-9.17 4.58L3.66 17.18"/><path d="m22 12-9.17 4.58L3.66 12"/>',
);

export {
  Icon,
  I_Home,
  I_Users,
  I_Building,
  I_Cal,
  I_Pulse,
  I_Settings,
  I_Search,
  I_Plus,
  I_X,
  I_Phone,
  I_Msg,
  I_Chev,
  I_ChevDown,
  I_LogOut,
  I_Spark,
  I_Img,
  I_Doc,
  I_Trash,
  I_Edit,
  I_Check,
  I_Up,
  I_Down,
  I_Alert,
  I_Clock,
  I_Flame,
  I_Snooze,
  I_Send,
  I_Filter,
  I_Pin,
  I_Ind,
  I_Refresh,
  I_User,
  I_Camera,
  I_Inbox,
  I_Layers,
};
